import { render, staticRenderFns } from "./ServiceCard.vue?vue&type=template&id=8f0212ec"
import script from "./ServiceCard.vue?vue&type=script&lang=ts"
export * from "./ServiceCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports